import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  Grid,
} from '@material-ui/core';
import {
  BackdropCircular,
  Breadcrumb
} from 'components';
import { getCustomerPushCartApi, getQuoteCustomerDataApi, getQuoteProProductsBySearchCriteriaApi } from 'api';
import { setFinalPageData } from 'redux/actions/quote';
import QuoteSummaryCard from './QuoteSummaryCard';
import QuoteSummaryTable from './QuoteSummaryTable';
import QuoteSummaryPatient from './QuoteSummaryPatient';


const QuoteSummary = () => {
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const dispatch = useDispatch();
  const {id} = useParams<{ [id: string]: string }>();

  const {
    quoteProducts,
    currentQuoteCustomer,
    customerPushCart,
    loadingDeleteQuoteItem,
    loadingConvertQuote,
    loadingQuoteTotals,
    quoteProductsLoading,
    loadingCustomerPushCart,
    loadingActiveMagentoCart,
    loadingAddItemsToQuote,
    loadingCheckout,
    loadingDraftedQuotes
  } = useSelector((state: IReduxState) => state.quote);

  const loading = loadingDeleteQuoteItem ||
                  loadingConvertQuote ||
                  quoteProductsLoading ||
                  loadingCustomerPushCart ||
                  loadingActiveMagentoCart ||
                  loadingAddItemsToQuote ||
                  loadingQuoteTotals ||
                  loadingCheckout ||
                  loadingDraftedQuotes;

  useEffect(() => {
    dispatch(setFinalPageData([], 30));

    if (!quoteProducts.length) {
      getQuoteProProductsBySearchCriteriaApi({
        dispatch,
        sortDirection: 'asc',
        sortField: 'name',
        pageSize: '',
        currentPage: '',
        filterConditions: [
          {
            field: 'status',
            value: '1',
            conditionType: 'eq'
          },
        ],
        searchConditions: []
      });
    }

    if (!currentQuoteCustomer?.id) {
      getQuoteCustomerDataApi({dispatch, id});
      getCustomerPushCartApi({
        dispatch,
        customerId: id
      });
    }
  }, []);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Create Quote', path: '/quoting'},
            { name: `${isCustomer3 ? 'Customer' : 'Patient'} Details`,
              path: `/quoting/profile/${currentQuoteCustomer?.id}`},
            { name: 'Quote Workspace', path: `/quoting/profile/${currentQuoteCustomer?.id}/quote-workspace` },
            { name: 'Quote Summary' }
          ]}
        />
      </div>
      <Grid container spacing={3} className="px-8">
        <Grid item xs={12} md={8}>
          {!!customerPushCart?.selectedItems?.length &&
          <QuoteSummaryTable />
          }
        </Grid>
        <Grid item xs={12} md={4}>
          <QuoteSummaryPatient />
          <br />
          {!!customerPushCart && <QuoteSummaryCard />}
        </Grid>
      </Grid>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default QuoteSummary;
